import { render, staticRenderFns } from "./blockchain.vue?vue&type=template&id=5beb18d6&scoped=true"
import script from "./blockchain.vue?vue&type=script&lang=js"
export * from "./blockchain.vue?vue&type=script&lang=js"
import style0 from "./blockchain.vue?vue&type=style&index=0&id=5beb18d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb18d6",
  null
  
)

export default component.exports